// extracted by mini-css-extract-plugin
export default {"write":"ReviewWrite2_write__fqiGS","selectStarRegist":"ReviewWrite2_selectStarRegist__AsoCd","productRating":"ReviewWrite2_productRating__u8At8"};